export default {
  banner: 'Thế giới thực trong không gian số',
  banner2: 'Nền tảng dữ liệu được tái tạo sống động.',
  desc: 'Trên thế giới có khoảng 10 zettabyte thông tin khổng lồ.<br/>ORBRO là nền tảng giúp hiển thị hóa những thông tin đó trong thế giới ảo.<br/>Trải nghiệm một thế giới mới, nơi thực và ảo được kết nối thành một.',
  over: 'ORBRO là dự án tái tạo và liên kết toàn bộ thông tin ý nghĩa trên Trái Đất theo thời gian thực.<br/>Từ đất, trời, biển, thành phố, con người cho đến chuyển động của phương tiện — bạn có thể cảm nhận một thế giới số còn thật hơn cả thực tế.',

  overSerial: [{ text: 'Thế giới giống nhau' }, { text: 'Biển giống nhau' }, { text: 'Thành phố giống nhau' }, { text: 'Chuyển động giống nhau' }],

  alive: [
    {
      title: 'Thông tin thành phố được quét nhanh chóng',
      titleColor: '#151515',
      text: 'Bạn có thể xem các thông tin liên quan đến tòa nhà như chiều cao, tên, địa chỉ, số tầng... được hiển thị đầy đủ trên ORBRO.',
      textColor: '#151515',
      size: 'type2',
    },
    {
      title: 'Hiểu rõ mọi tòa nhà trên thế giới',
      text: 'Toàn bộ các tòa nhà và công trình trên thế giới được trực quan hóa một cách chi tiết trong ORBRO. Từ căn hộ, công viên, hồ nước đến các biểu tượng thành phố — tất cả đều hiển thị rõ ràng và trực tiếp.',
      titleColor: '#151515',
      textColor: '#151515',
      size: 'type4',
    },
    {
      title: 'Thông tin đời sống cập nhật nhanh nhất',
      titleColor: '#151515',
      text: 'Từ trạm xe buýt, bến xe, sân bay đến CCTV công cộng và thậm chí cả cây cối — mọi đối tượng đều được hiển thị trên bản đồ. Có thể kết nối với ứng dụng để mở rộng không giới hạn.',
      textColor: '#151515',
      size: 'type4',
    },
    {
      title: 'Không chỉ 3D mà còn cả hình ảnh trực tiếp',
      titleColor: '#151515',
      text: 'ORBRO kết nối với nguồn phát video như camera IP hay CCTV ngoài đường và hiển thị trực tiếp trên bản đồ 3D.',
      textColor: '#151515',
      size: 'type2',
    },
    {
      title: 'Thông tin giao thông chân thực',
      titleColor: '#151515',
      text: 'Tuyến tàu điện ngầm, xe buýt, xe khách, máy bay, bến xe,... tất cả dữ liệu lớn được trực quan hóa và cập nhật thời gian thực trên không gian ảo.',
      textColor: '#151515',
      size: 'type5',
    },
    {
      title: 'Người đi bộ trên bản đồ',
      titleColor: '#151515',
      text: 'Ở nơi có hạ tầng ORBRO, mọi người di chuyển trong nhà và ngoài trời đều được hiển thị trên bản đồ.',
      textColor: '#151515',
      size: 'type2',
    },
    {
      title: 'Phương tiện chạy trên bản đồ',
      titleColor: '#151515',
      text: 'ORBRO hiển thị đầy đủ thông tin về xe cộ, từ xe đỗ đến xe đang di chuyển, giúp đánh giá lưu lượng và dự đoán tắc nghẽn giao thông.',
      textColor: '#151515',
      size: 'type4',
    },
    {
      title: 'Máy bay bay trên bản đồ',
      titleColor: '#151515',
      text: 'Từ lịch tàu điện ngầm đến các thông tin phương tiện như xe khách, máy bay, dữ liệu lớn được hiển thị thời gian thực trên bản đồ ảo.',
      textColor: '#151515',
      size: 'type4',
    },
    {
      title: 'Hiển thị thông tin sân bay theo thời gian thực',
      titleColor: '#fff',
      text: 'Bạn có thể xem thời gian đến và rời sân bay cùng thông tin về nhà ga. ORBRO liên kết thông tin máy bay theo thời gian thực.',
      textColor: '#fff',
      size: 'type2',
    },
    {
      title: 'Xem thời tiết bằng mắt thường',
      titleColor: '#151515',
      text: 'ORBRO cung cấp trải nghiệm mới về thời tiết — từ bụi mịn, siêu mịn,... mọi thông tin đều được hiển thị trực quan trên bản đồ.',
      textColor: '#151515',
      size: 'type2',
    },
    {
      title: 'Muốn biết xa hơn?',
      titleColor: '#fff',
      text: 'Trong thế giới ORBRO, thông tin thời tiết toàn cầu được liên kết. Bạn có thể nhìn thấy sự thay đổi thời tiết theo thời gian thực ở bất kỳ đâu.',
      textColor: '#fff',
      size: 'type4',
      shadow: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(96, 96, 96, 0.2) 45%, rgba(255, 255, 255, 0) 95%)',
    },
  ],

  infoSub: 'Thế giới thực hoạt động trong không gian ảo',
  info: 'ORBRO – Nơi lưu giữ<br/>thông tin thế giới thực',

  twinTitle: 'Đây chính là Digital Twin thực sự',
  twinSub: 'Cách chúng ta<br/>nhìn nhận thế giới',

  twin: [
    {
      title: 'Twin Tracker',
      text: 'Twin Tracker là thiết bị theo dõi toàn bộ băng tần Bluetooth 2.4GHz. Đây là thiết bị phân tích vị trí mạng đầu tiên trên thế giới được thương mại hóa sau 10 năm R&D.',
      deviceInfo: {
        width: '95mm',
        height: '95mm',
        thickness: '32.5mm',
        specifications: ['Cổng USB-C, PoE LAN', 'Ăng-ten định hướng'],
      },
      buttonType: 'black',
    },
    {
      title: 'Twin Vision',
      text: 'Twin Vision là thiết bị theo dõi vị trí sử dụng công nghệ camera stereo và AI. Nhờ công nghệ deep learning, thiết bị theo dõi chuyển động thời gian thực và tạo mô hình 3D trong thế giới ORBRO.',
      deviceInfo: {
        width: '185mm',
        height: '40mm',
        thickness: '39mm',
        specifications: ['Cảm biến kép 4MP, 2 micron pixel', 'Truyền hình ảnh tối ưu cho RTLS', 'Hiệu chỉnh hình ảnh chất lượng cao'],
      },
      buttonType: 'black',
    },
    {
      title: 'Phân tích chính xác vị trí trong nhà',
      text: 'Thiết bị Twin giúp phát hiện lối vào, lộ trình và thời gian lưu trú của khách — cung cấp cách phân tích chính xác nhất theo thời gian thực.',
    },
    {
      title: 'Tích lũy dữ liệu di chuyển chi tiết',
      text: 'Lưu trữ và phân tích chuyển động của từng khách tham quan trong không gian như thời gian, tốc độ di chuyển,... để cải thiện trải nghiệm không gian.',
    },
    {
      title: 'Theo dõi lộ trình theo từng người',
      text: 'Theo dõi chuyển động của từng khách theo ID. Dữ liệu đầy đủ về đường đi, thời gian lưu trú, tiếp xúc,... được lưu lại theo dòng thời gian.',
    },
    {
      title: 'Phân tích người dùng theo thời gian',
      text: 'Dễ dàng xem thời điểm nhiều người tập trung nhất trong ngày. Có thể ứng dụng trong marketing, quảng bá hoặc bố trí lại không gian.',
    },
    {
      title: 'Biểu thị bản đồ nhiệt không gian',
      text: 'Kết hợp với thông tin cá nhân, ORBRO nâng cao hiệu suất như kiểm soát ra vào theo quyền, chấm công, quản lý toàn diện.',
    },
    {
      title: 'Mở rộng nhờ liên kết thông tin cá nhân',
      text: 'Kết hợp thông tin người dùng giúp tối ưu quản lý người dùng như liên kết hệ thống ra vào, cơ sở dữ liệu,...',
    },
    {
      title: 'Phân tích vị trí tích hợp đầu tiên trên thế giới',
      text: 'ORBRO Twin kết hợp phân tích video và công nghệ sóng vô tuyến cho phép theo dõi siêu chính xác, mở ra cách mạng trong ngành công nghiệp.',
    },
    {
      title: 'Liên kết với thiết bị di động',
      text: 'Dùng công nghệ theo dõi bằng sóng, ORBRO có thể theo dõi điện thoại, thẻ, thiết bị điện tử và tạo ra dữ liệu phân tích người dùng.',
    },
    {
      title: 'Bảo vệ thông tin cá nhân',
      text: 'ORBRO không lưu bất kỳ dữ liệu cá nhân nào trên máy chủ nhằm bảo mật và bảo vệ quyền riêng tư người dùng.',
    },
  ],

  accessTitle: 'Hệ thống ra vào không tiếp xúc',
  accessSub: 'Giải pháp ra vào<br/>mới của tương lai',

  access: [
    {
      title: 'Access Pro',
      text: 'Access Pro cho phép quản lý quyền ra vào dựa trên thông tin người dùng, rất phù hợp cho những nơi cần kiểm soát nghiêm ngặt.',
      deviceInfo: {
        width: '160mm',
        height: '160mm',
        thickness: '38mm',
        weight: '258g',
        specifications: ['4 kênh T&C Engine', '2 kênh Bluetooth 5.0', 'Màn hình tròn TFT-LCD'],
      },
      buttonType: 'white',
    },
    {
      title: 'Access Lite',
      text: 'Access Lite cấp quyền ra vào cho tất cả người dùng đáp ứng điều kiện nhất định. Thích hợp với nơi công cộng, khu vực quản lý.',
      deviceInfo: {
        width: '210mm',
        height: '60mm',
        thickness: '43mm',
        weight: '156g',
        specifications: ['Cảm biến radar', 'Bộ lọc nhiễu', 'Bluetooth 5.0'],
      },
      buttonType: 'white',
    },
    {
      title: 'Thống kê khách truy cập theo thời gian thực',
      text: 'Dễ dàng kiểm tra thống kê theo hạng mục khác nhau của khách truy cập theo thời gian thực.',
    },
    {
      title: 'Lộ trình di chuyển theo khu vực',
      text: 'Bạn có tò mò khách đã đi những đâu? Hệ thống hiển thị đường đi từng tầng theo từng người.',
    },
  ],

  smartTitle: 'Điều khiển thiết bị từ xa',
  smartSub: 'Trải nghiệm không gian tối ưu<br/>từ bất cứ nơi nào',

  smart: [
    {
      title: 'Điều khiển điều hòa<br/>một cách dễ dàng mọi lúc',
      text: '',
    },
    {
      title: 'Điều khiển đèn<br/>chỉ với một cú chạm',
      text: '',
    },
    {
      title: 'Không chỉ chất lượng không khí<br/>mà cả thông tin nhiệt độ',
      text: '',
    },
    {
      title: 'Sản phẩm cho mọi nhu cầu',
      text: 'Các sản phẩm tương tác với ORBRO hỗ trợ trải nghiệm hoàn hảo cả online và offline.',
    },
  ],

  size: 'Kích thước và trọng lượng',
  width: 'Chiều ngang',
  thick: 'Độ dày',
  height: 'Chiều cao',
  weight: 'Trọng lượng',
  product: 'Thông số',

  dream: 'Tất cả chức năng<br/>của thế giới bạn mơ ước',
  app: 'Ứng dụng ORBRO cho mở rộng không giới hạn',
  download: 'Tải ứng dụng',
  solution: 'Nhiều giải pháp đã sẵn sàng.',
  more: 'Tìm hiểu thêm',

  platform: 'Bắt đầu với nền tảng',
  exp: 'Trải nghiệm thế giới mới kết nối với thực tại.',
  start: 'Bắt đầu',
};
